import React from 'react';

export function returnFromQnaPopup(event, href, browser = window) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!/^session-qna-/.test(browser.name || '')) return;
  const url = new URL(href, browser.location.href).href;
  try {
    const parent = browser.opener;
    if (parent && !parent.closed && parent.location.origin === browser.location.origin) {
      parent.location.assign(url);
      parent.focus();
      event.preventDefault();
      browser.close();
      return;
    }
  } catch {
    // A closed or isolated opener cannot be reused; open a normal browser tab.
  }
  const tab = browser.open(url, '_blank');
  if (tab) {
    tab.opener = null;
    tab.focus();
    event.preventDefault();
    browser.close();
  }
  // If the browser blocks the new tab, let the existing link navigate normally.
}

export default function DashboardReturnLink({ children, ...props }) {
  const href = '/portal/dashboard';
  return <a {...props} href={href} onClick={event => returnFromQnaPopup(event, href)}>{children}</a>;
}
